module.exports = __webpack_public_path__ + "755bd07c.svg";